import { FC, ButtonHTMLAttributes } from 'react';
import { Button } from '@new/common/ui/Button/Button';

interface CancelButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
  text?: string;
}

export const CancelButton: FC<CancelButtonProps> = ({
  disabled,
  onClick,
  text = 'Cancel',
  ...props
}) => {
  return <Button variant="neutral" onClick={onClick} disabled={disabled} text={text} {...props} />;
};
